module.exports = __webpack_public_path__ + "static/media/rMomSq.95c9adc3.png";